import { useTranslation } from 'next-i18next'
// Dependencies.
import styled from 'styled-components'

import { colors, forScreensGreaterThanMobileWidth } from '../utils'
import { H3 } from './H3'
import { P } from './P'
import { CreateEventCTA } from './CreateEventCTA'

// Div.
// const Div = styled.div`
//     height: 455px;
//     position: relative;
//     width: 100%;
//     overflow: hidden;
//     background: ${colors.paleOrange};
//     border-radius: 10px;
//     margin-bottom: 50px;

//     .backgroundImageContainer {
//         position: absolute;
//         width: 63%;
//         height: 471px;
//         left: -14%;
//         top: -75px;
//         border-radius: 33.4094px;
//         box-shadow: -20px 50px 40px rgba(0, 0, 0, 0.15);
//     }

//     .backgroundGroupRectangle {
//         width: 100%;
//         height: 100%;
//         background: ${colors.paleOrange};
//         border-radius: 33.4094px;
//         overflow:hidden;
//     }

//     .backgroupImageRectangle {
//         width: 100%;
//         height: 100%;
//         background: ${colors.paleOrange};
//         overflow: hidden;
//         border-radius: 33.4094px;
//         top: -10px;
//         left: -10px;
//         position: absolute;
//     }

//     .backgroundImage {
//         width: 100%;
//         height: 100%;
//         background-image: url('/images/aboutCTABackImage.png');
//         background-position:right bottom;
//         background-repeat:no-repeat;
//     }

//     .frontImageRectangle {
//         position: absolute;
//         width: 110.91px;
//         height: 169.4px;
//         right: 10px;
//         bottom: 10px;

//         background: #C4C4C4;
//         border-radius: 10.2668px;
//         overflow: hidden;
//     }

//     .frontImage {
//         width: 100%;
//         height: 100%;
//         background-image: url('/images/aboutCTAFrontImage.png');
//         background-position:right bottom;
//         background-repeat:no-repeat;
//     }

//     .contentContainer {
//         position:absolute;
//         width: 40%;
//         height: 47.6%;
//         right: 4%;
//         top: 26%;
//         max-width:100%;
//     }

//     .contentHeader {
//         text-align: left;
//         margin-bottom: 20px;
//     }

//     .contentText {
//         text-align: left;
//         margin-bottom: 30px;
//         width: 95%;
//     }
// `

const Div = styled.div`
  overflow: hidden;
  border-radius: 10px;
  background-color: ${colors.paleOrange};

  ${forScreensGreaterThanMobileWidth`
        display: flex;
        justify-content: space-between;
        align-items: center;
    `}

  .contentImage {
    box-sizing: border-box;
    width: 80%;
    ${forScreensGreaterThanMobileWidth`
            align-self: flex-start;
            width: 50%;
        `}
  }

  .contentContainer {
    box-sizing: border-box;
    width: 100%;
    padding: 30px;
    ${H3} {
      text-align: left;
    }
    ${P} {
      margin-top: 20px;
    }
    button {
      margin-top: 30px;
    }
    ${forScreensGreaterThanMobileWidth`
            .contentHeader { max-width: 400px; }
            .contentText { max-width: 328px; }
        `}
  }
`

// Props.
interface Props {
  bannerHeader: string
  bannerContent: string
  showCreateEventButton: boolean
}

// Hosted By.
export const CreateEventCTABanner: React.FC<Props> = (props) => {
  const { t } = useTranslation('common')

  const { bannerHeader, bannerContent, showCreateEventButton } = props

  // ..
  return (
    <Div>
      {/* Image. */}
      {/* <div className="backgroundImageContainer">
            <div className="backgroundGroupRectangle">
                <div className="backgroupImageRectangle">
                    <div className="backgroundImage">
                        <div className="frontImageRectangle">
                            <div className="frontImage"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div> */}
      <img
        className="contentImage"
        src="/images/aboutSlide.png"
        alt={t(`video call`, `video call`)}
      />

      {/* Content. */}
      <div className="contentContainer">
        <H3 className="contentHeader">{bannerHeader}</H3>
        <P className="contentText">{bannerContent}</P>

        {/* Navigate to create event page. */}
        {showCreateEventButton === true && (
          <CreateEventCTA purpleBackground={true} />
        )}
      </div>
    </Div>
  )
}
